import { defineStore } from 'pinia'
import * as Api from './api'
import { callWithMeta, createMeta, waitFor, type Meta } from '@/utils/store'

type State = {
  navigation?: Api.Navigation
  meta: Meta<{
    navigation: undefined
    load: undefined
  }>
}

const getDefaultState = (): State => ({
  navigation: undefined,
  meta: createMeta(['navigation', 'load']),
})

export const useNavigationStore = defineStore('navigation', {
  state: getDefaultState,

  getters: {
    uca: (state): boolean => state.navigation?.uca ?? false,
  },

  actions: {
    RESET() {
      this.navigation = getDefaultState().navigation
      this.meta.navigation = getDefaultState().meta.navigation
    },

    async load({ useCache = true } = {}) {
      const hasCached = ['pending', 'success'].includes(
        this.meta.navigation.status
      )

      if (useCache && hasCached) {
        await waitFor(() => this.meta.navigation.status !== 'pending')

        return
      }

      await callWithMeta({
        store: this,
        metaFields: { load: undefined, navigation: undefined },
        apiCall: async () => await Api.loadNavigation(),
        onSuccess: ({ isLatest, result }) => {
          if (isLatest('navigation')) {
            this.navigation = result.payload
          }
        },
      })
    },
  },
})
